import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StandardLayout = _resolveComponent("StandardLayout")!
  const _component_GameDialog = _resolveComponent("GameDialog")!
  const _component_ResearchDialog = _resolveComponent("ResearchDialog")!
  const _component_USIEngineManagementDialog = _resolveComponent("USIEngineManagementDialog")!
  const _component_AppSettingDialog = _resolveComponent("AppSettingDialog")!
  const _component_PasteDialog = _resolveComponent("PasteDialog")!
  const _component_BussyMessage = _resolveComponent("BussyMessage")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_InfoMessage = _resolveComponent("InfoMessage")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_StandardLayout, { class: "main" }),
    (_ctx.dialogVisibilities.game)
      ? (_openBlock(), _createBlock(_component_GameDialog, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.dialogVisibilities.research)
      ? (_openBlock(), _createBlock(_component_ResearchDialog, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.dialogVisibilities.usiEngineSetting)
      ? (_openBlock(), _createBlock(_component_USIEngineManagementDialog, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.dialogVisibilities.appSetting)
      ? (_openBlock(), _createBlock(_component_AppSettingDialog, { key: 3 }))
      : _createCommentVNode("", true),
    (_ctx.dialogVisibilities.paste)
      ? (_openBlock(), _createBlock(_component_PasteDialog, { key: 4 }))
      : _createCommentVNode("", true),
    (_ctx.dialogVisibilities.bussy)
      ? (_openBlock(), _createBlock(_component_BussyMessage, { key: 5 }))
      : _createCommentVNode("", true),
    (_ctx.dialogVisibilities.confirm)
      ? (_openBlock(), _createBlock(_component_ConfirmDialog, { key: 6 }))
      : _createCommentVNode("", true),
    (_ctx.hasMessage)
      ? (_openBlock(), _createBlock(_component_InfoMessage, { key: 7 }))
      : _createCommentVNode("", true),
    (_ctx.hasErrors)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, { key: 8 }))
      : _createCommentVNode("", true)
  ], 64))
}